import React from "react";
import { formatRupiah } from "../../../helper/formatNumber";

import "../../sales/common_component/salesSummary.css";

const ProfitSummary = ({ summaryData, total_transaction_profit }) => {
  return (
    <div className="sales-summary-container">
      <h3>Detail Penjualan</h3>
      <div className="sales-summary-transaction-table">
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Cash :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.cash_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Transfer :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.transfer_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Debit :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.debit_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">QR :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.qr_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Kartu Kredit :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.credit_card_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Rekanan :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.partner_transaction)}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <p className="sales-summary-column-title">Total Transaksi :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData.total_transaction)}</b>
          </p>
        </div>
      </div>
      <div className="separator" />
      <div className="sales-summary-row">
        <h2 className="sales-summary-column-title-transaction">Profit:</h2>
        <h3 className="sales-summary-column">
          <b>{formatRupiah(total_transaction_profit)}</b>
        </h3>
      </div>
    </div>
  );
};

export default ProfitSummary;
